import React from 'react';
import { MUITable, MUITablePagination, MUITableSorting } from 'components/shared/MUITable';

import { DealSheetRulesTableRow } from '../types';
import { Description, RuleName, RuleValue } from './cells';

interface Props {
  isLoading: boolean;
  sorting: MUITableSorting;
  pagination: MUITablePagination;
  tableData: Record<string, any>[];
}

export const DealSheetRulesTable = ({ tableData, ...props }: Props) => {
  const mappedTableData: DealSheetRulesTableRow[] = !tableData.length
    ? []
    : tableData.map(rule => ({
        id: rule.id,
        name: rule.name,
        description: rule.description,
        createdDateTime: rule.createdDateTime,

        propCustomerType: rule.dealRules.customer?.type,
        propCustomerPaymentType: rule.dealRules.customer?.paymentType,

        propLocationZip: rule.dealRules.location?.zip,
        propLocationCity: rule.dealRules.location?.city,
        propLocationState: rule.dealRules.location?.state,
        propLocationCounty: rule.dealRules.location?.county,
        propLocationCountry: rule.dealRules.location?.country,

        propEquipmentType: rule.dealRules.equipment?.type,
      }));

  return (
    <MUITable<DealSheetRulesTableRow>
      tableData={mappedTableData}
      {...props}
      columns={[
        {
          header: 'Rule',
          renderKey: 'name',
          sortKey: 'rule_name',
          renderCell: rule => <RuleName rule={rule} />,
          cellProps: { align: 'left' },
        },
        {
          header: 'Description',
          sortKey: 'description',
          renderKey: 'description',
          renderCell: rule => <Description rule={rule} />,
          cellProps: { align: 'left' },
        },
        {
          header: 'Customer',
          renderKey: 'propCustomerType',
          renderCell: rule => <RuleValue rule={rule} ruleKey="propCustomerType" />,
        },
        {
          header: 'Payment',
          renderKey: 'propCustomerPaymentType',
          renderCell: rule => <RuleValue rule={rule} ruleKey="propCustomerPaymentType" />,
        },
        {
          header: 'Country',
          renderKey: 'propLocationCountry',
          renderCell: rule => <RuleValue rule={rule} ruleKey="propLocationCountry" />,
        },
        {
          header: 'State',
          renderKey: 'propLocationState',
          renderCell: rule => <RuleValue rule={rule} ruleKey="propLocationState" />,
        },
        {
          header: 'County',
          renderKey: 'propLocationCounty',
          renderCell: rule => <RuleValue rule={rule} ruleKey="propLocationCounty" />,
        },
        {
          header: 'City',
          renderKey: 'propLocationCity',
          renderCell: rule => <RuleValue rule={rule} ruleKey="propLocationCity" />,
        },
        {
          header: 'ZIP Code',
          renderKey: 'propLocationZip',
          renderCell: rule => <RuleValue rule={rule} ruleKey="propLocationZip" />,
        },
        {
          header: 'Equipment',
          renderKey: 'propEquipmentType',
          renderCell: rule => <RuleValue rule={rule} ruleKey="propEquipmentType" />,
        },
      ]}
    />
  );
};
